define('LNRS/Track/TrackPageEvents',[
    "jquery",
    "Track/DataLayerManager",
    "Track/TrackFilters"
], function ($, dlmanager, trackFilters) {

    var templates = {
        SubjectMatterExpertBioPage: "5012B725-2116-4DF2-B4B3-97F21198D254",
        SubjectMatterExpertsListingPage: "F3BFBC02-2251-4993-A449-295A2FE16528",
        SubjectMatterExpertsSubjectPage: "F3649847-DC9F-426B-8131-A4DAFB5F64F8",
        IndustryPage: "B106503B-DE36-4C69-95D2-8ECF22E7FB66",
        SubIndustryPage: "CF77088A-8138-4C00-BDCE-C99AD4A8378A",
        ProductPage: "828E9E61-311A-441C-B9BE-228ACBB9332B",
        ResourcePage: "351839DE-0AA0-448A-8832-2429282C1B78",
        ContentPage: "B28ACA0E-D521-4651-B425-A3CD3F84CC30",
        ResourceListingPage: "2C3F16E7-70FF-4C4E-912C-AEFBB41B269E",
        PressReleasePage: "6B540238-0C7F-4A78-A0E0-DD51C1AD1E59"      
    },
    pages = {
        "404": "5874C0C2-A668-42D2-8476-8DBF72280374"
    };

    function removeSpecialCharacters(inputString) {
        return inputString.replace(/[^a-zA-Z0-9\s\-,()_:]+/g, "");
    }

    return function trackPageEvents(pageId, templateId, title, parentTitle, type, industrySearchTags, solutionSearchTags, industryName, subIndustrySearchTags, subIndustryName) {
        var o = { site_events: {} }, def = $.Deferred(), promise = def.promise();
        def.resolve();

        // 7.1.1 View Subject Matter Expert Profile
        if (templateId === templates.SubjectMatterExpertBioPage) {
            o.site_events["view_sme_profile"] = "true";
        }
        else if (templateId === templates.SubjectMatterExpertsListingPage) {
            
        }
        else if (templateId === templates.SubjectMatterExpertsSubjectPage) {
            
        }
            // 7.2.1 Industry Pages
        else if (templateId === templates.IndustryPage) {
            o.site_events["view_industry_page"] = "true";
        }
            // 7.2.2 Sub-Industry Pages
        else if (templateId === templates.SubIndustryPage) {
            o.site_events["view_subindustry_page"] = "true";
        }
            // 7.2.3 Product/Solutions Pages
        else if (templateId === templates.ProductPage) {
            o.site_events["product_detail_view"] = "true";
            o["product_name"] = title;
        }
            // 7.6 Insights&Resources
        else if (templateId === templates.ResourcePage) {
            o.site_events["view_knowledge_content"] = "true";
            o["content_type"] = type;
            o["solution_name"] = removeSpecialCharacters(solutionSearchTags);
        }
            // 7.10.11 Apply Filters
        else if (templateId === templates.ResourceListingPage) {
            trackFilters(dlmanager);
            return promise;
        }
        // Content Page
        else if (templateId === templates.ContentPage && pageId !== pages["404"]) {
            
        }
            // Press Release Page
        else if (templateId === templates.PressReleasePage) {
            o["solution_name"] = removeSpecialCharacters(solutionSearchTags);
            o.site_events["press_release_content"] = "true";
        }
            // 7.8.2 Error Pages
        else if (templateId === templates.ContentPage && pageId === pages["404"]) {
            o.site_events["error_page"] = "true";
            o["error_page_type"] = "404 not found";
            o["error_page_url"] = window.location.href;
        }
        else {
            return promise;
        }

        if (Object.keys(o.site_events).length > 0) {
            dlmanager.trackAnalytics(o);
        }

        return promise;
    };
});
